<div>
  <h3>Logga in</h3>
  @if (loginForm) {
    <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">
      <label aria-label="användarnamn">
        <mat-icon>person</mat-icon>
        <input formControlName="username" (focus)="notFound = undefined" id="username" type="text"
          placeholder="e-post" autocomplete="off">
        </label>
        <label aria-label="lösenord">
          <mat-icon>lock</mat-icon>
          <input formControlName="password" (focus)="notFound = undefined" id="password" type="password"
            placeholder="lösenord" autocomplete="off">
          </label>
          <mat-slide-toggle id="slide-toggle" [checked]="driverMode"
            (change)="setDriverModePreference($event.checked)" [color]="'primary'" aria-label="Aktivera chaufförläge">
            Chaufförläge
          </mat-slide-toggle>
          <p class="form-error">{{notFound || ''}}</p>
          <button class="button" type="submit" [disabled]="!loginForm.valid">
            Logga in
          </button>
        </form>
      }
      <div class="forgotPassword">
        <button mat-button (click)="forgotPassword()">Glömt lösenord</button>
      </div>

    </div>